import { Component, forwardRef, Input, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputBase } from '../input-base/input-base';

const INPUT_RADIO_VALUE_ACCESSOR = {
	provide: NG_VALUE_ACCESSOR,
	// eslint-disable-next-line no-use-before-define, @typescript-eslint/no-use-before-define
	useExisting: forwardRef(() => InputRadioComponent),
	multi: true,
};

@Component({
	selector: 'app-input-radio',
	templateUrl: './input-radio.component.html',
	styleUrls: ['../input-base/input-styles.scss', './input-radio.component.scss'],
	providers: [INPUT_RADIO_VALUE_ACCESSOR],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class InputRadioComponent extends InputBase implements ControlValueAccessor {
	// eslint-disable-next-line @angular-eslint/no-input-rename
	@Input({ required: true }) radioValue: any;

	select() {
		if (this.disabled) return;
		this.value = this.radioValue;
		this.onChange(this.radioValue);
		this.onTouched();
	}
}
